
// You can delete this file if you're not using it
import React from 'react'
import { DynamicProvider } from './src/context'

export const wrapRootElement = ({ element }) => (
  <DynamicProvider>{element}</DynamicProvider>
)